(function () {
  var configElement = document.getElementById('processing-capabilities-config-' + document.currentScript.getAttribute('data-section-id'));
  if (!configElement) return;
  var config = JSON.parse(configElement.textContent);
  var sectionId = config.sectionId;
  var isEnglish = config.isEnglish;
  var isHexProduct = config.isHexProduct;
  var isRoundMaterial = config.productHandle === 'aluminium-profile-rund';
  var placeholderHeading = config.heading;
  var pendingPrompt = isEnglish ? 'Please select an alloy first' : 'Bitte zuerst eine Legierung auswählen';
  var pendingDescription = isEnglish ? 'Processing options differ by aluminium alloy. Select an alloy in the configurator to see the relevant guidance for sawing, welding, drilling, milling and other processing methods.' : 'Die Bearbeitungsmöglichkeiten unterscheiden sich je nach Aluminiumlegierung. Wähle im Konfigurator eine Legierung aus, um die passenden Hinweise zu Sägen, Schweißen, Bohren, Fräsen und weiteren Bearbeitungsverfahren anzuzeigen.';
  var pendingDimensionNote = isEnglish ? 'Available alloys depend on the selected dimension.' : 'Die verfügbaren Legierungen richten sich nach der gewählten Abmessung.';
  var noMappingPrompt = isEnglish ? 'No complete processing guidance is currently available for this alloy.' : 'Für diese Legierung liegen derzeit keine vollständigen Bearbeitungshinweise vor.';
  var noMappingDescription = isEnglish ? 'Please contact us if you need specific processing advice for the selected alloy.' : 'Bitte frag uns, wenn Du konkrete Hinweise zur Bearbeitung der gewählten Legierung benötigst.';
  var hasUserSelectedAlloy = false;
  var suppressAlloySelection = false;
  var lastDimensionSignature = '';

  var jsonCache = new WeakMap();

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    var text = el.textContent;
    var cached = jsonCache.get(el);
    if (cached && cached.text === text) return cached.value;
    var value = null;
    try { value = JSON.parse(text); } catch (e) {}
    jsonCache.set(el, { text: text, value: value });
    return value;
  }

  function setDisplay(el, value) {
    if (el.style.display !== value) el.style.display = value;
  }

  function setAttribute(el, name, value) {
    if (el.getAttribute(name) === value) return;
    if (value === null) el.removeAttribute(name);
    else el.setAttribute(name, value);
  }

  function getWrap() {
    return document.getElementById('processing-capabilities-wrap-' + sectionId);
  }

  function displayAlloyLabel(alloyKey) {
    var wrap = getWrap();
    var handle = wrap && wrap.getAttribute('data-product-handle') || '';
    if (handle === 'pv-profile' && alloyKey === 'AlMgSi0,7') {
      return 'EN AW-6063 / AlMg0,7Si';
    }
    return alloyKey;
  }

  function getMap() {
    return readJson('processing-capabilities-map-' + sectionId);
  }

  function statusToUI(status) {
    if (status === 'medium') return { color: '#8b6504', symbol: '-', label: config.statusLabels.medium };
    if (status === 'bad') return { color: '#9b3937', symbol: '✗', label: config.statusLabels.bad };
    return { color: '#2f7645', symbol: '✓', label: config.statusLabels.good };
  }

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(element) {
    if (!element || element.closest('.processing-capabilities-wrap, [hidden], [aria-hidden="true"]')) {
      return false;
    }

    if (window.getComputedStyle) {
      var style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') {
        return false;
      }
    }

    return element.getClientRects().length > 0 || Boolean(element.offsetWidth || element.offsetHeight);
  }

  function isElementVisible(element) {
    if (!element || element.closest('[hidden], [aria-hidden="true"]')) {
      return false;
    }

    if (window.getComputedStyle) {
      var style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') {
        return false;
      }
    }

    return element.getClientRects().length > 0 || Boolean(element.offsetWidth || element.offsetHeight);
  }

  function getSectionContainer(element) {
    return element && (element.closest('.shopify-section') || element.closest('[id^="shopify-section-"]') || element.parentElement);
  }

  function hideDuplicateProcessingSections(currentWrap) {
    var wraps = document.querySelectorAll('.processing-capabilities-wrap');

    for (var i = 0; i < wraps.length; i++) {
      if (wraps[i] === currentWrap) break;

      if (wraps[i].getAttribute('data-processing-active') === 'true' || isElementVisible(wraps[i])) {
        setDisplay(currentWrap, 'none');
        setAttribute(currentWrap, 'data-processing-duplicate', 'true');
        return false;
      }
    }

    setAttribute(currentWrap, 'data-processing-active', 'true');
    setAttribute(currentWrap, 'data-processing-duplicate', null);

    var allSections = document.querySelectorAll('.processing-capabilities');
    for (var j = 0; j < allSections.length; j++) {
      var section = allSections[j];
      if (currentWrap.contains(section)) continue;

      var otherWrap = section.closest('.processing-capabilities-wrap');
      if (otherWrap) {
        if (otherWrap !== currentWrap) {
          setDisplay(otherWrap, 'none');
          setAttribute(otherWrap, 'data-processing-duplicate', 'true');
        }
        continue;
      }

      var container = getSectionContainer(section);
      if (container) {
        setDisplay(container, 'none');
        setAttribute(container, 'data-processing-duplicate', 'true');
      } else {
        setDisplay(section, 'none');
        setAttribute(section, 'data-processing-duplicate', 'true');
      }
    }

    return true;
  }

  function getKnownAlloyKeys() {
    return [
      'AlMgSi0,5',
      'AlMgSi0,7',
      'AlMgSi1',
      'AlMgSiBi',
      'AlZnMgCu1,5',
      'AlCuMg1',
      'AlCuMgPb',
      'AlCuBiPb',
      'AlMg4,5Mn',
      'AlMg3',
      'AlMg1',
      'Al99,5'
    ];
  }

  function getNormToAlloy() {
    return {
      '6060': 'AlMgSi0,5',
      '6063': 'AlMgSi0,7',
      '6005': 'AlMgSi0,7',
      '6082': 'AlMgSi1',
      '6026': 'AlMgSiBi',
      '7075': 'AlZnMgCu1,5',
      '2007': 'AlCuMgPb',
      '2011': 'AlCuBiPb',
      '2017': 'AlCuMg1',
      '1050': 'Al99,5',
      '5083': 'AlMg4,5Mn',
      '5754': 'AlMg3',
      '5005': 'AlMg1'
    };
  }

  function escapeRegExp(value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function getFriendlyAlloyLabel(alloy) {
    var cleanAlloy = cleanText(alloy);
    var alloyKey = normalizeAlloyKey(cleanAlloy);
    if (isRoundMaterial) {
      var roundProduct = getProductJson();
      var dimension = compactValue(getSelectedDimensionText());
      var selectedControl = document.getElementById('legierung-select');
      var selectedValue = selectedControl && selectedControl.value;
      var rows = roundProduct && roundProduct.variants || [];
      for (var r = 0; r < rows.length; r++) {
        var row = rows[r];
        if (compactValue(row.option1) !== dimension) continue;
        if (row.option2 !== cleanAlloy && (!alloyKey || normalizeAlloyKey(row.option2) !== alloyKey)) continue;
        if (selectedValue && normalizeAlloyKey(selectedValue) === alloyKey && row.option2 !== selectedValue) continue;
        var grade = (row.sku || '').split('-')[1] || '';
        var baseGrade = grade.replace(/LF$/i, '');
        if (getNormToAlloy()[baseGrade] === alloyKey) {
          return 'EN AW-' + grade.replace(/LF$/i, ' LF') + ' (' + row.option2 + ')';
        }
        return row.option2;
      }
      return cleanAlloy;
    }
    if (!alloyKey) return cleanAlloy;
    if (/^EN AW-\d{4}\s*\//i.test(cleanAlloy)) return cleanAlloy;

    var product = getProductJson();
    var dimensionText = getSelectedDimensionText();
    var dimensionNeedle = compactValue(dimensionText);
    if (product && product.variants) {
      for (var i = 0; i < product.variants.length; i++) {
        var variant = product.variants[i];
        var variantText = [
          variant.title,
          variant.option1,
          variant.option2,
          variant.option3,
          variant.sku
        ].join(' ');
        if (dimensionNeedle && compactValue(variantText).indexOf(dimensionNeedle) === -1) continue;
        if (normalizeAlloyKey(variantText) !== alloyKey) continue;
        var match = variantText.match(/\b(?:EN\s*)?AW[-\s]?(\d{4})\b/i);
        if (match) return 'EN AW-' + match[1] + ' (' + alloyKey + ')';
      }
    }

    var fallbackGrades = {
      'AlMgSi0,5': '6060',
      'AlMgSi0,7': '6063',
      'AlMgSi1': '6082',
      'AlMgSiBi': '6026 LF',
      'AlZnMgCu1,5': '7075',
      'AlCuMg1': '2017',
      'AlCuMgPb': '2007',
      'AlCuBiPb': '2011',
      'AlMg4,5Mn': '5083',
      'AlMg3': '5754',
      'AlMg1': '5005',
      'Al99,5': '1050'
    };
    return fallbackGrades[alloyKey] ? 'EN AW-' + fallbackGrades[alloyKey] + ' (' + alloyKey + ')' : cleanAlloy;
  }

  function decorateAlloyOptions() {
    var selects = document.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      if (!isVisible(select) || !isAlloyControl(select)) continue;
      for (var j = 0; j < select.options.length; j++) {
        var option = select.options[j];
        var key = normalizeAlloyKey(option.textContent || option.value);
        if (!key || !isAlloyOfferedForCurrentDimension(key)) continue;
        var label = getFriendlyAlloyLabel(isRoundMaterial ? option.value : key);
        if (label && option.textContent !== label) option.textContent = label;
      }
    }
  }

  function updateHeading(alloy) {
    var wrap = getWrap();
    var heading = wrap && wrap.querySelector('h2');
    if (!heading) return;
    var displayAlloy = alloy ? getFriendlyAlloyLabel(alloy) : '';
    var text = displayAlloy ? placeholderHeading + ' ' + displayAlloy : placeholderHeading;
    if (heading.textContent !== text) heading.textContent = text;
  }

  function getControlsNearLabel(label) {
    var controls = [];
    var selector = 'select, input, textarea, button, [role="combobox"], [aria-haspopup], [aria-expanded]';

    function addControls(container) {
      if (!container || !container.querySelectorAll) return;
      var found = container.querySelectorAll(selector);
      for (var i = 0; i < found.length; i++) {
        if (isVisible(found[i]) && controls.indexOf(found[i]) === -1) {
          controls.push(found[i]);
        }
      }
    }

    var forId = label.getAttribute && label.getAttribute('for');
    if (forId) {
      var linked = document.getElementById(forId);
      if (linked && isVisible(linked)) {
        controls.push(linked);
      }
    }

    addControls(label.closest('.variant-wrapper, .product-block, .line-item-property__field, .field, .form-field') || label.parentElement);

    var node = label;
    for (var depth = 0; node && depth < 4; depth++, node = node.parentElement) {
      var sibling = node.nextElementSibling;
      for (var index = 0; sibling && index < 4; index++, sibling = sibling.nextElementSibling) {
        if (/^(Maße|Dicke|Breite|Länge|Menge)\b/i.test(cleanText(sibling))) {
          break;
        }
        addControls(sibling);
      }
    }

    return controls;
  }

  function getControlText(control) {
    if (!control || !isVisible(control)) return '';

    if (control.matches && control.matches('select')) {
      var option = control.options && control.selectedIndex >= 0 ? control.options[control.selectedIndex] : null;
      return cleanText((option && option.textContent) || control.value);
    }

    if (control.matches && control.matches('input[type="radio"], input[type="checkbox"]')) {
      if (!control.checked) return '';
      return cleanText(control.value);
    }

    if ('value' in control && cleanText(control.value)) {
      return cleanText(control.value);
    }

    return cleanText(control.textContent || control.getAttribute('aria-label') || control.getAttribute('title') || '');
  }

  function getLegierungControlTexts() {
    var texts = [];
    var labels = document.querySelectorAll('label, .variant__label, [class*="label"]');

    function addText(text) {
      text = cleanText(text);
      if (text && texts.indexOf(text) === -1) {
        texts.push(text);
      }
    }

    for (var i = 0; i < labels.length; i++) {
      if (!isVisible(labels[i])) continue;

      var labelText = cleanText(labels[i]).toLowerCase();
      if (/^legierung\b/.test(labelText)) {
        var controls = getControlsNearLabel(labels[i]);
        for (var j = 0; j < controls.length; j++) {
          addText(getControlText(controls[j]));
        }

        addText(labels[i].textContent);
      }
    }

    var fallbackControls = document.querySelectorAll('select, input');
    for (var k = 0; k < fallbackControls.length; k++) {
      if (!isVisible(fallbackControls[k])) continue;

      var attrs = [
        fallbackControls[k].name,
        fallbackControls[k].id,
        fallbackControls[k].getAttribute('data-handle'),
        fallbackControls[k].getAttribute('aria-label')
      ].join(' ').toLowerCase();

      if (attrs.indexOf('legierung') !== -1 || attrs.indexOf('alloy') !== -1) {
        addText(getControlText(fallbackControls[k]));
      }
    }

    return texts;
  }

  function getLegierungOptionTexts() {
    var texts = [];
    var labels = document.querySelectorAll('label, .variant__label, [class*="label"]');

    function addText(text) {
      text = cleanText(text);
      if (text && texts.indexOf(text) === -1) {
        texts.push(text);
      }
    }

    function addOptionTextsFrom(container) {
      if (!container || !container.querySelectorAll) return;

      var options = container.querySelectorAll('option, [role="option"], [data-value], button, li');
      for (var i = 0; i < options.length; i++) {
        addText(options[i].textContent || options[i].value || options[i].getAttribute('data-value'));
      }
    }

    for (var i = 0; i < labels.length; i++) {
      var labelText = cleanText(labels[i]).toLowerCase();
      if (!/^legierung\b/.test(labelText)) continue;

      var controls = getControlsNearLabel(labels[i]);
      for (var j = 0; j < controls.length; j++) {
        if (controls[j].matches && controls[j].matches('select')) {
          var selectOptions = controls[j].options || [];
          for (var k = 0; k < selectOptions.length; k++) {
            addText(selectOptions[k].textContent || selectOptions[k].value);
          }
        }

        addOptionTextsFrom(controls[j].closest('.variant-wrapper, .product-block, .line-item-property__field, .field, .form-field') || controls[j].parentElement);
      }

      addOptionTextsFrom(labels[i].closest('.variant-wrapper, .product-block, .line-item-property__field, .field, .form-field') || labels[i].parentElement);
    }

    var fallbackControls = document.querySelectorAll('select, input');
    for (var m = 0; m < fallbackControls.length; m++) {
      var attrs = [
        fallbackControls[m].name,
        fallbackControls[m].id,
        fallbackControls[m].getAttribute('data-handle'),
        fallbackControls[m].getAttribute('aria-label')
      ].join(' ').toLowerCase();

      if (attrs.indexOf('legierung') === -1 && attrs.indexOf('alloy') === -1) continue;

      if (fallbackControls[m].matches && fallbackControls[m].matches('select')) {
        var fallbackOptions = fallbackControls[m].options || [];
        for (var n = 0; n < fallbackOptions.length; n++) {
          addText(fallbackOptions[n].textContent || fallbackOptions[n].value);
        }
      } else {
        addText(fallbackControls[m].value);
      }
    }

    return texts;
  }

  function getAlloyFromDropdown() {
    var texts = getLegierungControlTexts();

    for (var i = 0; i < texts.length; i++) {
      var normalized = normalizeAlloyKey(texts[i]);
      if (normalized) return normalized;
    }

    return '';
  }

  function getAlloyFromLegierungOptions() {
    var texts = getLegierungOptionTexts();

    for (var i = 0; i < texts.length; i++) {
      var normalized = normalizeAlloyKey(texts[i]);
      if (normalized) return normalized;
    }

    return '';
  }

  function hasLegierungField() {
    return getLegierungControlTexts().length > 0;
  }

  function getProductJson() {
    var productData = readJson('pc-product-json-' + sectionId);
    if (isRoundMaterial && productData && !productData.roundVariantsReady) {
      productData.variants = (productData.configurationVariants || []).map(function(row) {
        return { id: row.SKU, title: row.Abmessung + ' ' + row.Legierung,
          option1: row.Abmessung, option2: row.Legierung, sku: row.SKU };
      });
      productData.roundVariantsReady = true;
    }
    return productData;
  }

  function getSelectedVariantText() {
    var product = getProductJson();
    if (!product || !product.variants) return '';

    var idControls = document.querySelectorAll('form[action*="/cart/add"] [name="id"], [name="id"]');
    var selectedId = '';

    for (var i = 0; i < idControls.length; i++) {
      if (idControls[i].closest('.processing-capabilities-wrap')) continue;
      selectedId = idControls[i].value || selectedId;
      if (isVisible(idControls[i]) || idControls[i].closest('form[action*="/cart/add"]')) {
        break;
      }
    }

    if (!selectedId) return '';

    for (var j = 0; j < product.variants.length; j++) {
      var variant = product.variants[j];
      if (String(variant.id) === String(selectedId)) {
        return [
          variant.title,
          variant.option1,
          variant.option2,
          variant.option3,
          variant.sku
        ].join(' ');
      }
    }

    return '';
  }

  function isAlloyOfferedForCurrentDimension(alloyKey) {
    var dimensionText = getSelectedDimensionText();
    var dimensionNeedle = compactValue(dimensionText);
    var product = getProductJson();
    if (!alloyKey || !dimensionNeedle || isPlaceholderValue(dimensionText) || !product || !product.variants) return false;

    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      var variantText = [
        variant.title,
        variant.option1,
        variant.option2,
        variant.option3,
        variant.sku
      ].join(' ');
      if (isRoundMaterial ? compactValue(variant.option1) !== dimensionNeedle : compactValue(variantText).indexOf(dimensionNeedle) === -1) continue;
      if (normalizeAlloyKey(variantText) === alloyKey) return true;
    }

    return false;
  }

  function getAlloyFromProductJson() {
    var dimensionText = getSelectedDimensionText();
    var dimensionNeedle = compactValue(dimensionText);
    var product = getProductJson();
    if (!dimensionNeedle || isPlaceholderValue(dimensionText) || !product || !product.variants) return '';

    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      var variantText = [
        variant.title,
        variant.option1,
        variant.option2,
        variant.option3,
        variant.sku
      ].join(' ');
      if (compactValue(variantText).indexOf(dimensionNeedle) === -1) continue;
      var normalized = normalizeAlloyKey(variantText);
      if (normalized) return normalized;
    }

    return '';
  }

  function getTechDetailsText() {
    var headings = document.querySelectorAll('h1,h2,h3,h4');
    var techHeading = null;

    for (var i = 0; i < headings.length; i++) {
      var txt = (headings[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (txt === 'technische details') {
        techHeading = headings[i];
        break;
      }
    }

    if (!techHeading) return '';

    var container = techHeading.closest('section, .shopify-section, .page-width, div') || techHeading.parentElement;
    if (!container) return '';

    return (container.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function getFallbackProductText() {
    var wrap = getWrap();
    if (!wrap) return '';

    var title = wrap.getAttribute('data-product-title') || '';
    var handle = wrap.getAttribute('data-product-handle') || '';
    var sku = wrap.getAttribute('data-first-variant-sku') || '';

    return [title, handle, sku].join(' ');
  }

  function isSystemProfileProduct() {
    var productText = cleanText([
      getFallbackProductText(),
      getSelectedVariantText()
    ].join(' ')).toLowerCase();

    if (!productText) return false;
    if (/\b(zubeh[oö]r|verbinder|nutenstein|abdeckkappe)\b/i.test(productText)) return false;

    return /\b(systemprofil|systemprofile|systembauprofil|leichtbauprofil)\b/i.test(productText);
  }

  function normalizeAlloyKey(raw) {
    if (!raw) return '';

    var t = String(raw).replace(/\s+/g, ' ').trim();
    var tl = t.toLowerCase();

    // Nur diese Liste muss mit den Mapping-Keys zusammenpassen
    var directKeys = getKnownAlloyKeys();

    for (var i = 0; i < directKeys.length; i++) {
      if (tl.indexOf(directKeys[i].toLowerCase()) !== -1) return directKeys[i];
    }

    // Normnummern -> Mapping-Key
    var normToAlloy = getNormToAlloy();

    var awMatch = t.match(/\b(?:EN\s*)?A?W[-\s]?(\d{4})\b/i);
    if (awMatch && awMatch[1] && normToAlloy[awMatch[1]]) {
      return normToAlloy[awMatch[1]];
    }

    var numMatch = t.match(/(?:^|[^0-9])(\d{4})(?:[^0-9]|$)/);
    if (numMatch && numMatch[1] && normToAlloy[numMatch[1]]) {
      return normToAlloy[numMatch[1]];
    }

    return '';
  }

  function getFixedSystemAlloy() {
    var wrap = getWrap();
    if (!wrap || !isSystemProfileProduct()) return '';
    var grade = wrap.getAttribute('data-product-grade') || '';
    var material = normalizeAlloyKey(grade) || normalizeAlloyKey(wrap.getAttribute('data-product-alloy'));
    if (material) return material;
    var description = wrap.getAttribute('data-product-material-text') || '';
    var matches = getKnownAlloyKeys().filter(function(key) {
      return description.toLowerCase().indexOf(key.toLowerCase()) !== -1;
    });
    return matches.length === 1 ? matches[0] : '';
  }

  function getAlloyKey() {
    if (isRoundMaterial) {
      var control = document.getElementById('legierung-select');
      var dimension = compactValue(getSelectedDimensionText());
      var roundProduct = getProductJson();
      var rows = roundProduct && roundProduct.variants || [];
      if (!control || isPlaceholderValue(control.value)) return '';
      for (var r = 0; r < rows.length; r++) {
        if (compactValue(rows[r].option1) === dimension && rows[r].option2 === control.value) {
          return normalizeAlloyKey(control.value) || control.value;
        }
      }
      return '';
    }
    if (isSystemProfileProduct()) return getFixedSystemAlloy();

    // 1) Legierung-Dropdown
    var fromDropdown = getAlloyFromDropdown();
    if (fromDropdown && isAlloyOfferedForCurrentDimension(fromDropdown)) return fromDropdown;

    // 2) Gewählte Shopify-Variante
    var variantText = getSelectedVariantText();
    var normalizedVariant = normalizeAlloyKey(variantText);
    if (normalizedVariant && isAlloyOfferedForCurrentDimension(normalizedVariant)) return normalizedVariant;

    // Wenn ein Legierungsfeld vorhanden ist, nicht aus Produkttexten raten:
    // Dort stehen oft mehrere Legierungen, wodurch sonst die falsche gewinnt.
    if (hasLegierungField()) {
      var fromLegierungOptions = getAlloyFromLegierungOptions();
      if (fromLegierungOptions && isAlloyOfferedForCurrentDimension(fromLegierungOptions)) return fromLegierungOptions;

      var fromProductJson = getAlloyFromProductJson();
      if (fromProductJson && isAlloyOfferedForCurrentDimension(fromProductJson)) return fromProductJson;

      return '';
    }

    // 3) Technische Details
    var techText = getTechDetailsText();
    var normalizedTech = normalizeAlloyKey(techText);
    if (normalizedTech) return normalizedTech;

    // 4) Titel / Handle / SKU
    var fallbackText = getFallbackProductText();
    var normalizedFallback = normalizeAlloyKey(fallbackText);
    if (normalizedFallback) return normalizedFallback;

    return '';
  }

  function applyStatuses(statuses) {
    var wrap = getWrap();
    if (!wrap) return;

    var boxes = wrap.querySelectorAll('.capability-box');

    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var capKey = box.getAttribute('data-cap-key');
      if (!capKey) continue;

      var status = statuses[capKey];
      if (!status) continue;

      var ui = statusToUI(status);

      var rating = box.querySelector('.capability-box__rating');
      if (rating && rating.textContent !== ui.label) rating.textContent = ui.label;

      var badge = box.querySelector('.capability-box__status');
      if (badge) {
        if (badge.style.background !== ui.color) badge.style.background = ui.color;
        if (badge.textContent !== ui.symbol) badge.textContent = ui.symbol;
        badge.setAttribute('aria-label', ui.label);
      }
      box.setAttribute('role', 'group');
      box.setAttribute('aria-label', cleanText(box.querySelector('.capability-box__title') && box.querySelector('.capability-box__title').textContent) + ': ' + ui.label);
    }
  }

  function getCapabilityDefinitions() {
    return config.definitions;
  }

  function ensureCapabilityCards() {
    var wrap = getWrap();
    var grid = wrap && wrap.querySelector('.processing-capabilities__grid');
    if (!grid || grid.querySelector('.capability-box')) return;

    var fragment = document.createDocumentFragment();
    var definitions = getCapabilityDefinitions();

    for (var i = 0; i < definitions.length; i++) {
      var item = definitions[i];
      var box = document.createElement('div');
      box.className = 'capability-box';
      box.setAttribute('data-cap-key', item.key);

      var badge = document.createElement('div');
      badge.className = 'capability-box__status';
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = '';
      box.appendChild(badge);

      var iconWrap = document.createElement('div');
      iconWrap.className = 'capability-box__icon';
      var image = document.createElement('img');
      image.src = item.icon;
      image.alt = '';
      image.loading = 'lazy';
      image.width = 120;
      image.height = 120;
      iconWrap.appendChild(image);
      box.appendChild(iconWrap);

      var title = document.createElement('div');
      title.className = 'capability-box__title';
      title.textContent = item.title;
      box.appendChild(title);

      var rating = document.createElement('div');
      rating.className = 'capability-box__rating';
      box.appendChild(rating);

      var link = document.createElement('a');
      link.className = 'capability-box__link';
      link.href = item.href;
      link.textContent = item.guide;
      box.appendChild(link);

      fragment.appendChild(box);
    }

    grid.appendChild(fragment);
  }

  function setPlaceholderCopy(promptText, descriptionText, dimensionNoteText) {
    var wrap = getWrap();
    var placeholder = wrap && wrap.querySelector('[data-processing-placeholder]');
    if (!placeholder) return;
    var prompt = placeholder.querySelector('.processing-capabilities__prompt');
    var description = placeholder.querySelector('.processing-capabilities__description');
    var dimensionNote = placeholder.querySelector('.processing-capabilities__dimension-note');
    if (prompt) prompt.textContent = promptText;
    if (description) description.textContent = descriptionText;
    if (dimensionNote) {
      dimensionNote.textContent = dimensionNoteText;
      dimensionNote.hidden = !dimensionNoteText;
    }
  }

  function showPendingState() {
    var wrap = getWrap();
    if (!wrap) return;
    var placeholder = wrap.querySelector('[data-processing-placeholder]');
    var grid = wrap.querySelector('.processing-capabilities__grid');
    setDisplay(wrap, '');
    if (placeholder) {
      placeholder.removeAttribute('hidden');
      setPlaceholderCopy(pendingPrompt, pendingDescription, pendingDimensionNote);
    }
    if (grid) {
      grid.setAttribute('hidden', '');
      setDisplay(grid, 'none');
    }
    setAttribute(wrap, 'data-processing-active', null);
    updateHeading('');
  }

  function showMatrixState() {
    var wrap = getWrap();
    if (!wrap) return;
    var placeholder = wrap.querySelector('[data-processing-placeholder]');
    var grid = wrap.querySelector('.processing-capabilities__grid');
    if (placeholder) placeholder.setAttribute('hidden', '');
    if (grid) {
      ensureCapabilityCards();
      grid.removeAttribute('hidden');
      setDisplay(grid, '');
    }
  }

  function showNoMappingState() {
    var wrap = getWrap();
    if (!wrap) return;
    var grid = wrap.querySelector('.processing-capabilities__grid');
    setDisplay(wrap, '');
    setPlaceholderCopy(noMappingPrompt, noMappingDescription, '');
    var placeholder = wrap.querySelector('[data-processing-placeholder]');
    if (placeholder) placeholder.removeAttribute('hidden');
    if (grid) {
      grid.setAttribute('hidden', '');
      setDisplay(grid, 'none');
    }
    setAttribute(wrap, 'data-processing-active', null);
    updateHeading('');
  }

  function update() {
    var wrap = getWrap();
    decorateAlloyOptions();
    if (!wrap) return;

    var showOnly = (wrap.getAttribute('data-show-only-when-mapped') === 'true');
    var map = getMap();

    if (!map) {
      showPendingState();
      setAttribute(wrap, 'data-processing-active', null);
      updateHeading('');
      return;
    }

    var fixedHexAlloy = isHexProduct ? normalizeAlloyKey(getFallbackProductText()) : '';
    var fixedSystemAlloy = getFixedSystemAlloy();
    var alloyKey = fixedHexAlloy || fixedSystemAlloy || (hasUserSelectedAlloy ? getAlloyKey() : '');

    if (!alloyKey) {
      if (isSystemProfileProduct()) showNoMappingState();
      else showPendingState();
      setAttribute(wrap, 'data-processing-active', null);
      updateHeading('');
      return;
    }

    var statuses = map[alloyKey];

    if (statuses) {
      if (!hideDuplicateProcessingSections(wrap)) {
        updateHeading('');
        return;
      }

      setDisplay(wrap, '');
      showMatrixState();
       applyStatuses(statuses);
      updateHeading(displayAlloyLabel(alloyKey));
    } else if (showOnly && !isRoundMaterial) {
      setDisplay(wrap, 'none');
      setAttribute(wrap, 'data-processing-active', null);
      updateHeading('');
    } else {
      showNoMappingState();
    }
  }

  var scheduled = false;
  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      update();
    });
  }

  function getUpdateTarget() {
    return document.querySelector('#tab-produktansicht') || document.querySelector('[data-product-blocks]') || document.body;
  }

  function getControlScope(element) {
    if (!element || !element.closest) return element && element.parentElement;
    return element.closest('fieldset, [data-option-index], .variant-input-wrap, .variant-wrapper, .pk-input-container, .product-block, .line-item-property__field, .field, .form-field, [role="group"]') || element.parentElement;
  }

  function isPlaceholderValue(value) {
    return !value || /^(Bitte|Wähle|Bitte wähle|Select|Choose)/i.test(cleanText(value));
  }

  function getSelectedFieldText(pattern) {
    var labels = document.querySelectorAll('label, .variant__label, [class*="label"]');
    for (var i = 0; i < labels.length; i++) {
      if (!isVisible(labels[i]) || !pattern.test(cleanText(labels[i]))) continue;
      var controls = getControlsNearLabel(labels[i]);
      for (var j = 0; j < controls.length; j++) {
        var value = getControlText(controls[j]);
        if (!isPlaceholderValue(value) && !pattern.test(value)) return value;
      }
    }
    return '';
  }

  function getSelectedControlTextByMatcher(matcher) {
    var controls = document.querySelectorAll('select, input, [role="combobox"]');
    for (var i = 0; i < controls.length; i++) {
      var control = controls[i];
      if (!isVisible(control)) continue;
      var attrs = [
        control.name,
        control.id,
        control.getAttribute('data-handle'),
        control.getAttribute('aria-label'),
        control.getAttribute('data-option-name')
      ].join(' ');
      if (!matcher.test(attrs)) continue;
      var value = getControlText(control);
      if (!isPlaceholderValue(value)) return value;
    }
    return '';
  }

  function getSelectedAlloyText() {
    return getSelectedControlTextByMatcher(/(legierung|alloy)/i) || getSelectedFieldText(/^Legierung\b|^Alloy\b/i);
  }

  function getSelectedDimensionText() {
    return getSelectedControlTextByMatcher(/(maße|masse|abmessung|durchmesser|dimension|size)/i) || getSelectedFieldText(/^(Maße|Masse|Abmessung|Durchmesser|Dimension|Size)\b/i);
  }

  function isAlloyControl(element) {
    if (!element || !element.closest) return false;
    if (element.closest('.pk-container')) return !!element.closest('#legierung-select');
    if (element.closest('.product-form__submit, [type="submit"], .input-number-container')) return false;
    var scope = getControlScope(element);
    var attrs = [
      element && element.name,
      element && element.id,
      element && element.getAttribute && element.getAttribute('data-handle'),
      element && element.getAttribute && element.getAttribute('aria-label'),
      scope && scope.getAttribute && scope.getAttribute('data-handle'),
      scope && scope.getAttribute && scope.getAttribute('data-option-name'),
      scope && scope.textContent
    ].join(' ');
    return /\b(legierung|alloy)\b/i.test(attrs);
  }

  function isDimensionControl(element) {
    if (!element || !element.closest) return false;
    if (element.closest('.pk-container')) return !!element.closest('#durchmesser-select');
    if (element.closest('.product-form__submit, [type="submit"], .input-number-container')) return false;
    var scope = getControlScope(element);
    var attrs = [
      element && element.name,
      element && element.id,
      element && element.getAttribute && element.getAttribute('data-handle'),
      element && element.getAttribute && element.getAttribute('aria-label'),
      scope && scope.getAttribute && scope.getAttribute('data-handle'),
      scope && scope.getAttribute && scope.getAttribute('data-option-name'),
      scope && scope.textContent
    ].join(' ');
    return /\b(maße|masse|abmessung|durchmesser|dimension|size)\b/i.test(attrs);
  }

  function compactValue(value) {
    return cleanText(value).toLowerCase().replace(/[×*]/g, 'x').replace(/\s+/g, '');
  }

  function isCurrentAlloyAvailable() {
    var alloyText = getSelectedAlloyText();
    var dimensionText = getSelectedDimensionText();
    var product = getProductJson();
    if (isPlaceholderValue(alloyText) || isPlaceholderValue(dimensionText)) return false;
    if (!product || !product.variants || !product.variants.length) return false;

    var alloyKey = normalizeAlloyKey(alloyText);
    var dimensionNeedle = compactValue(dimensionText);
    for (var i = 0; i < product.variants.length; i++) {
      var variantText = [product.variants[i].title, product.variants[i].option1, product.variants[i].option2, product.variants[i].option3, product.variants[i].sku].join(' ');
      var variantCompact = compactValue(variantText);
      if ((!alloyKey || normalizeAlloyKey(variantText) === alloyKey) && variantCompact.indexOf(dimensionNeedle) !== -1) return true;
    }
    return false;
  }

  function resetAlloySelection() {
    var controls = getUpdateTarget().querySelectorAll('select, input, button, [role="combobox"]');
    var reset = false;
    for (var i = 0; i < controls.length; i++) {
      var control = controls[i];
      if (!isAlloyControl(control) || control.closest('.processing-capabilities-wrap, .pk-container')) continue;
      if (control.matches('select')) {
        if (control.value !== '') {
          control.value = '';
          suppressAlloySelection = true;
          control.dispatchEvent(new Event('change', { bubbles: true }));
        }
        reset = true;
      } else if (control.matches('input[type="radio"], input[type="checkbox"]')) {
        if (control.checked) control.checked = false;
        reset = true;
      } else if (control.matches('button, [role="combobox"]')) {
        var placeholder = isEnglish ? 'Please choose an alloy.' : 'Bitte wählen Sie eine Legierung.';
        control.textContent = placeholder;
        control.setAttribute('aria-label', isEnglish ? 'Alloy: ' + placeholder : 'Legierung: ' + placeholder);
        reset = true;
      }
    }
    hasUserSelectedAlloy = false;
    if (reset) scheduleUpdate();
  }

  function bindEvents() {
    function onInput(event) {
      var el = event.target;
      if (suppressAlloySelection) {
        suppressAlloySelection = false;
      } else if (isAlloyControl(el)) {
        var selectedOption = el.matches('option, [role="option"], input[type="radio"], input[type="checkbox"]') || el.getAttribute('aria-selected') === 'true';
        if (event.type === 'change' || event.type === 'input' || (event.type === 'click' && selectedOption)) {
          hasUserSelectedAlloy = !el.matches('select') || !isPlaceholderValue(el.value);
        }
      } else if (event.type === 'change' && isDimensionControl(el)) {
        var configurator = el.closest('.pk-container');
        if (configurator) {
          // The app owns the alloy options; this section only displays processing guidance.
          var alloyControl = configurator.querySelector('#legierung-select');
          hasUserSelectedAlloy = !!alloyControl && !isPlaceholderValue(alloyControl.value);
        } else if (hasUserSelectedAlloy && !isCurrentAlloyAvailable()) {
          resetAlloySelection();
        }
      }
      if (!el || !el.closest || el.closest('.processing-capabilities-wrap')) return;
      var target = getUpdateTarget();
      if ((target && target.contains(el)) || el.matches('[name="id"]')) scheduleUpdate();
    }
    document.addEventListener('change', onInput);
    document.addEventListener('input', onInput);
    document.addEventListener('click', onInput, true);
    document.addEventListener('variant:change', scheduleUpdate);
    window.addEventListener('pageshow', scheduleUpdate);
  }

  function initProcessing() {
    bindEvents();
    update();

    // Falls technische Details nachgeladen werden
    setTimeout(update, 300);
    setTimeout(update, 1200);

    if (window.MutationObserver) {
      var target = getUpdateTarget();
      var observer = new MutationObserver(function(records) {
        var relevant = records.some(function(record) {
          var el = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          return el && !el.closest('.processing-capabilities-wrap');
        });
        if (relevant) scheduleUpdate();
      });
      observer.observe(target, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'value', 'checked', 'selected', 'aria-selected', 'aria-expanded']
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProcessing, { once: true });
  else initProcessing();
})();
